import type { SVGProps } from 'react';
export const Eta = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M6.3 4.27V6.5L10 9.2l3.7-2.73v-2.2zM8.91 10 5.48 7.49A1.2 1.2 0 0 1 5 6.55V4.17q.01-.48.35-.83c.22-.22.53-.34.85-.34h7.6q.5 0 .85.34t.35.83v2.36a1.1 1.1 0 0 1-.47.93L11.08 10l3.44 2.54a1.2 1.2 0 0 1 .48.93v2.36q-.01.47-.35.83-.35.34-.85.34H6.2q-.5 0-.85-.34a1.2 1.2 0 0 1-.35-.83v-2.38a1.1 1.1 0 0 1 .48-.94zm1.09.8 3.7 2.72v2.2H6.3V13.5z"
      clipRule="evenodd"
    />
  </svg>
);
